import GetRegisteredDeviceActions from "@redux/feature/BasicProfile/actions/GetRegisteredDevices";
import GetProfilePicActions from "@redux/feature/BasicProfile/actions/GetProfilePic";
import ClientDetailsGroupsActions from "@redux/feature/BasicProfile/actions/ClientDetails";
import IGetRmDetailsGroupsActions from "@redux/feature/BasicProfile/actions/GetRmDetails";
import DeleteProfilePicActions from "@redux/feature/BasicProfile/actions/DeleteProfilePic";
import SaveProfilePicActions from "@redux/feature/BasicProfile/actions/SaveProfilePic";
export default (function () {
    return {
        basicProfile: {
            clientDetails: new ClientDetailsGroupsActions(),
            getRegisteredDeviceDetails: new GetRegisteredDeviceActions(),
            getRmDetails: new IGetRmDetailsGroupsActions(),
            getProfilePic: new GetProfilePicActions(),
            saveProfilePic: new SaveProfilePicActions(),
            deleteProfilePic: new DeleteProfilePicActions(),
        },
    };
});
